/* eslint max-statements: 0 */
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'

function getRelativeDate (diff) {
  if (diff.seconds < 15) {
    return <FormattedMessage id='relativedate.justnow' defaultMessage='just now' />
  }

  if (diff.seconds < 60) {
    return <FormattedMessage id='relativedate.secondsago' defaultMessage='{diff} seconds ago' values={{ diff: diff.seconds }} />
  }

  if (diff.seconds < 120) {
    return <FormattedMessage id='relativedate.minuteago' defaultMessage='a minute ago' />
  }

  if (diff.seconds < 2700) {
    return <FormattedMessage id='relativedate.minutesago' defaultMessage='{diff} minutes ago' values={{ diff: diff.minutes }} />
  }

  if (diff.seconds < 5400) {
    return <FormattedMessage id='relativedate.hourago' defaultMessage='an hour ago' />
  }

  if (diff.seconds < 86400) {
    return <FormattedMessage id='relativedate.hoursago' defaultMessage='about {diff} {diff, plural, one {hour} other {hours}} ago' values={{ diff: diff.hours }} />
  }

  if (diff.seconds < 172800) {
    return <FormattedMessage id='relativedate.yesterday' defaultMessage='a day ago' />
  }

  if (diff.seconds < 2592000) {
    return <FormattedMessage id='relativedate.daysago' defaultMessage='{diff} days ago' values={{ diff: diff.days }} />
  }

  if (diff.seconds < 31104000) {
    if (diff.months === 1) {
      return <FormattedMessage id='relativedate.aboutamonth' defaultMessage='about a month ago' />
    }

    return <FormattedMessage id='relativedate.monthsago' defaultMessage='{diff} months ago' values={{ diff: diff.months }} />
  }

  return <FormattedMessage id='relativedate.yearsago' defaultMessage='{diff} {diff, plural, one {year} other {years}} ago' values={{ diff: diff.years }} />
}

export function RelativeDate ({ date }) {
  const dateMoment = moment(date)

  const diff = {
    seconds: moment().diff(dateMoment, 'seconds'),
    minutes: moment().diff(dateMoment, 'minutes'),
    hours: moment().diff(dateMoment, 'hours'),
    days: moment().diff(dateMoment, 'days'),
    months: moment().diff(dateMoment, 'months'),
    years: moment().diff(dateMoment, 'years'),
  }

  const component = getRelativeDate(diff)

  return (
    <span>
      {component}
    </span>
  )
}

RelativeDate.propTypes = {
  date: PropTypes.string,
}

export default RelativeDate
